import React, { useState, useEffect } from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import LeftPanel from "../include/leftpanel";
import axios from "axios";
import Global from "../../APIConfig";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import AuthUser from "../../AuthUser";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Barcode from "../../Barcode";
import QRCode from 'qrcode.react';

function ShipmentLabel() {
    let navigate = useNavigate();
    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
      };
    const query = useQuery();
    const slipno = query.get('slipno');
    const [list, setList] = useState([]);
    const [logo, setLogo] = useState([]);
    const { headers1, headers2, logout } = AuthUser();
    const [printMode, setPrintMode] = useState('print-4x6');
    
    useEffect(() => {
        GetLabel();
    }, []);

  //    useEffect(() => {
  //   GetLabel();
  // }, []);

    useEffect(() => {
        const mode = localStorage.getItem('print_mode');

        if (mode === 'a4') {
            setPrintMode('print-a4');
        } else {
            setPrintMode('print-4x6');
        }

        // Auto print
        //   setTimeout(() => {
        //     window.print();
        //   }, 300);
    }, []);

    const GetLabel = () => {
        axios({
            method: 'post',
            url: Global.baseUrl + 'ShipmentLabel',
            headers: headers1,
            data: {
                slip_no: slipno
            }
        })
            .then(function (response) {
                if (response.data.status == 200) {
                    var data = response.data.value;
                    setList(data);
                }
            })
            .catch(function (error) {
                if (error.response.status == 401) {
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                // console.log(error);
            });
    }

    return (
       <>
      <style>{`
        @media print {
          body { margin: 0; padding: 0; background-color: #fff }
          .container { width: 100%; max-width: none; }
          .no-print { display: none; }
        }

        .label-box {
          font-family: Arial, Helvetica, sans-serif;
          border: 1px solid black;
          max-width: 4in;
          max-height: 6in;
          margin: auto;
          font-size: 12px;
          font-weight: 400;
        }

        .logo { max-height: 50px; }

        .img-fluid {
          max-width: 100%;
          height: 40px;
        }

        h1 { font-size: 22px; margin: 0; font-weight: 700; }
        h2 { font-size: 13px; margin: 0; font-weight: 400; }
        h3 { font-size: 12px; margin: 0; font-weight: 400; }
        h4 { font-size: 12px; margin: 0; font-weight: 400; }
        h6 { font-size: 13px; font-weight: 700; margin-bottom: 4px; }

        table {
          border-collapse: collapse;
          width: 100%;
        }

        td, th {
          vertical-align: top;
        }

        /* A4 mode */
        .print-a4 {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
        }

        .print-a4 .label-box {
        // width: 100%;
        }

        /* 4x6 mode */
        .print-4x6 .label-box {
        width: 4in;
        height: 6in;
        margin: auto;
        page-break-after: always;
        }

        /* Page sizes */
        @media print {
        body { margin: 0; }
        }

        // @page {
        size: A4;
        margin: 10mm;
        }

        // @page :first {
        //  width: 4in;
        // height: 6in;
        // }
      `}</style>

      {list != undefined ? (
        <>
        <div id="print-root" className={printMode}>
          {list.map((ship, index) => {
            return (
              <div id="label-content" className="label-box">
                <table>
                  <tbody>
                    <tr>
                      <td style={{ width: "60%" }}>
                        <h2>To:</h2>
                        <h3>{ship.reciever_name}</h3>
                        <h3>{ship.reciever_address}</h3>
                        <h3>Mobile No: {ship.reciever_phone}</h3>
                      </td>
                      <td>
                        <img
                          src={`${Global.logoUrl}${ship.logo}`}
                          className="logo img-fluid"
                          alt={`${logo.company_name}`}
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <h3>
                          Order Date: <strong>{ship.entrydate}</strong>
                        </h3>
                        <h3>
                          Invoice No: <strong>{ship.invoice_no}</strong>
                        </h3>
                        <h3>
                          WEIGHT:{" "}
                          <strong>
                            {ship.volumetric_weight}
                            {ship.weightType}
                          </strong>
                        </h3>
                        <h3>
                          Dimensions (cm):{" "}
                          <strong>
                            {ship.height}cm x {ship.width}cm x {ship.length}
                          </strong>
                        </h3>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <h4>
                          {ship.customer_booking_mode === "COD" ? "COD" : ""}
                        </h4>
                        <h1>
                          {ship.customer_booking_mode === "COD" ? "₹" : ""}
                          {ship.customer_booking_mode === "COD"
                            ? ship.total_cod_amt
                            : "PREPAID"}
                        </h1>
                      </td>
                    </tr>

                    <tr>
                      <td style={{ textAlign: "center" }}>
                        {/* Barcode SVG */}
                        <div className="col-md-8">
                          {" "}
                          <Barcode value={ship.slip_no} />{" "}
                        </div>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <div className="col-md-4">
                          {" "}
                          <QRCode
                            value={ship.slip_no}
                            size={75}
                            style={{
                              height: "70px",
                              width: "65px",
                              margin: "5px",
                            }}
                          />{" "}
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={2} style={{ textAlign: "center" }}>
                        <h1>{ship.slip_no}</h1>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <br />

                <table class="" style={{ border: "1px solid #000" }}>
                  <thead style={{ border: "1px solid #000" }}>
                    <tr>
                      <th>Type</th>
                      <th>Item Name</th>
                      <th>Qty.</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ border: "1px solid #000" }}>{ship.nrd}</td>
                      <td style={{ border: "1px solid #000" }}>
                        {ship.status_describtion}
                      </td>
                      <td style={{ border: "1px solid #000" }}>1</td>
                      <td style={{ border: "1px solid #000" }}>
                        &#8377;
                        {ship.customer_booking_mode === "COD"
                          ? ship.total_cod_amt
                          : ship.declared_charge}
                      </td>
                    </tr>
                    <tr>
                      <td colspan="3" style={{ border: "1px solid #000" }}>
                        Order Total:
                      </td>
                      <td style={{ border: "1px solid #000" }}>
                        &#8377;
                        {ship.customer_booking_mode === "COD"
                          ? ship.total_cod_amt
                          : ship.declared_charge}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <br />

                <div>
                  <h2>
                    <strong>Pickup Address:</strong>
                  </h2>
                  <h3>{ship.sender_name}</h3>
                  <h3>
                    {ship.sender_address}, {ship.senderstate},
                    {ship.sendercountry} - {ship.sender_zip}
                  </h3>
                  <h3>Mobile No: {ship.sender_phone}</h3>
                </div>

                {/* <br /> */}

                <div>
                  <h2>For any query please contact:</h2>
                  <h3>Mobile: 9999999999, Email: hello@domain.com</h3>
                </div>

                <hr />
                <small>
                  This is a computer generated document, signature not required.
                </small>
              </div>
            );
          })}
          </div>
        </>
      ) : (
        ""
      )}
    </>
    );
}
export default ShipmentLabel;